<script lang="ts">
    import { spaLink } from "../../actions"

    export let button: CallToActionButton
</script>

<button class="cta {button.ctaType == 0 ? 'primary' : 'secondary'}">
    <a
        use:spaLink
        href="{button.page}"
        target="{button.buttonTarget}"
    >
        {button.buttonText}</a
    >
</button>

<style lang="less">
</style>
